require('./global-footer.scss');



//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/global-footer/global-footer.js
// module id = 28
// module chunks = 0 1 2 3 4 5 6 8 9 10 11 12 13 14